// Source/Boost-Pagination/mod.ts
var Block_Id = `boost_ai_search_filter_filter_product_list`;
var block = document.querySelector(`[ id *= '${Block_Id}' ]`);
console.debug("block", block);
if (block) {
  const observer = new MutationObserver(check);
  observer.observe(block, {
    childList: true,
    subtree: true
  });
}
function check() {
  const pagination = block.querySelector(`.boost-sd__pagination`);
  if (!pagination)
    return;
  const isPatched = pagination.dataset.isPatched;
  if (isPatched === "true")
    return;
  pagination.dataset.isPatched = String(true);
  pagination.addEventListener("click", (event) => {
    if (event.target === pagination)
      return;
    window.scrollTo({
      behavior: "smooth",
      top: 0
    });
  }, {
    capture: true
  });
}
